module.exports = __webpack_public_path__ + "img/equate_severe_cold_flu.1c1fe201.png";